import { LANGUAGES, SKILLS } from "@/lib/sunoVoicesApi";

export const inp = "w-full rounded-xl border border-white/10 bg-black/40 px-3.5 py-2.5 text-[14px] text-white placeholder:text-white/30 focus:border-cyan-300/50 focus:outline-none";
export const lbl = "mb-1 mt-4 block font-mono text-[10px] uppercase tracking-[0.16em] text-white/50";

/** Name · singing level · language · style for a new Suno voice. */
export default function VoiceDetailsFields({ value, onChange }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div>
      <label className={lbl} htmlFor="sv-name">Voice name</label>
      <input id="sv-name" data-testid="suno-voice-name" className={inp} value={value.name} maxLength={60} onChange={set("name")} />
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={lbl} htmlFor="sv-skill">Singing level</label>
          <select id="sv-skill" data-testid="suno-voice-skill" className={inp} value={value.skill} onChange={set("skill")}>
            {SKILLS.map(([k, l]) => <option key={k} value={k} className="bg-zinc-900">{l}</option>)}
          </select>
        </div>
        <div>
          <label className={lbl} htmlFor="sv-lang">Phrase language</label>
          <select id="sv-lang" data-testid="suno-voice-language" className={inp} value={value.language} onChange={set("language")}>
            {LANGUAGES.map(([k, l]) => <option key={k} value={k} className="bg-zinc-900">{l}</option>)}
          </select>
        </div>
      </div>
      <label className={lbl} htmlFor="sv-style">Your sound (optional)</label>
      <input id="sv-style" data-testid="suno-voice-style" className={inp} value={value.style} maxLength={200} placeholder="e.g. warm male gospel lead, Jamaican accent" onChange={set("style")} />
    </div>
  );
}
